import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { IProduct, PRODUCT_TTL_ES } from '../../product.interface';
import { ProductService } from '../../product.service';

@Component({
  selector: 'pg-product-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ProductSelectComponent extends SelectTemplate {
  constructor(private productService: ProductService) {
    super(PRODUCT_TTL_ES, productService);
  }

  ngOnInit() {
    this.table.settings = {
      title: PRODUCT_TTL_ES,
      columns: [
        { header: 'Código', field: 'itemCode' },
        { header: 'Descripción', field: 'itemName' },
        { header: 'Principio Activo', field: 'activesIngredients' },
        { header: 'Laboratorio', field: 'laboratoryDescription' },
        { header: 'Grupos Terapeutas', field: 'therapistGroups' },
        { header: 'Unidad de Medida', field: 'unitMeasureDescription' },
        { header: 'Simbolo de Medida', field: 'unitMeasureSymbol' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.productService
      .getData$()
      .subscribe((data: IProduct[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
